import { render, staticRenderFns } from "./iegc.vue?vue&type=template&id=2c855690&scoped=true&"
import script from "./iegc.vue?vue&type=script&lang=js&"
export * from "./iegc.vue?vue&type=script&lang=js&"
import style0 from "./iegc.vue?vue&type=style&index=0&id=2c855690&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c855690",
  null
  
)

export default component.exports